/* eslint-env browser */
import { find, on } from 'domassist';

export default function(gaTrack) {
  find(`a:not([href*="${location.host}"])`)
    .filter(e => e.href.indexOf(location.host) < 0)
    .forEach(e => {
      on(e, 'click', event => {
        if (typeof e.dataset.outbound !== 'undefined') {
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        gaTrack.sendEvent('pdat', 'outbound', e.href, () => {
          e.dataset.outbound = 'true';
          e.click();
        });
      }, true);
    });
}
